import axios from 'axios';
import { useState } from 'react';
import { Axios } from '../axios/config';

export const useAxiosGet = () => {
  // ================= State ====================
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const getRequest = async (url, config = {}, baseUrl = true) => {
    try {
      setIsSuccess(false);
      setIsLoading(true);
      let response;
      if (baseUrl) {
        response = await Axios.get(url, { ...config });
      } else {
        response = await axios(url, { ...config });
      }
      setIsLoading(false);
      setIsSuccess(true);
      return { data: response.data };
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      return {
        error: error?.message || error?.message || error,
        data: error?.data,
      };
    }
  };

  return [getRequest, { isLoading, isError, isSuccess }];
};

export const useAxiosPost = () => {
  // ================= State ====================
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const postRequest = async (url, data, config = {}) => {
    try {
      setIsSuccess(false);
      setIsLoading(true);

      const response = await Axios.post(url, data, { ...config });

      setIsLoading(false);
      setIsSuccess(true);
      return { data: response.data };
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      return {
        error: error?.message || error?.message || error,
        data: error?.data,
      };
    }
  };

  return [postRequest, { isLoading, isError, isSuccess }];
};

export const useAxiosPatch = () => {
  // ================= State ====================
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const patchRequest = async (url, data, config = {}) => {
    try {
      setIsSuccess(false);
      setIsLoading(true);
      const response = await Axios.patch(url, data, { ...config });
      setIsLoading(false);
      setIsSuccess(true);
      return { data: response.data };
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      return {
        error: error?.message || error?.message || error,
        data: error?.data,
      };
    }
  };

  return [patchRequest, { isLoading, isError, isSuccess }];
};

export const useAxiosDelete = () => {
  // ================= State ====================
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const deleteRequest = async (url, config) => {
    try {
      setIsSuccess(false);
      setIsLoading(true);
      const response = await Axios.delete(url, { ...config });
      setIsLoading(false);
      setIsSuccess(true);
      return { data: response.data };
    } catch (error) {
      setIsError(true);
      setIsLoading(false);
      return {
        error: error?.message || error?.message || error,
        data: error?.data,
      };
    }
  };

  return [deleteRequest, { isLoading, isError, isSuccess }];
};
